import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

const {
  init: initRequest,
  setPayload,
  setResponse,
  fetching,
  fetchingSuccess,
  fetchingFail,
  abortFetching,
} = createAllActions(types.SCOPE);

export {
  initRequest,
  setPayload,
  setResponse,
  fetching,
  fetchingSuccess,
  fetchingFail,
  abortFetching,
};
